import React from "react";
import "./pages.css";
import RecipesLoop from "../components/recipesLoop";

function Recipes({ handleLogout, deleteItem, user }) {
  return (
    <>
      <section className="mainSection">
        <nav className="hero">
          <h1 className="sr-only">Recipes Page</h1>
          <button onClick={handleLogout}>Log Out</button>
        </nav>

        <main>
          <RecipesLoop deleteItem={deleteItem} user={user} />
        </main>
      </section>
    </>
  );
}

export default Recipes;
